{
  "title": "Ménages",
  "search": "Recherche",
  "state": "État",
  "archiveHousehold": "Archives Ménage",
  "editHousehold": "Ajouter au ménage",
  "houseHold": "Ménage",
  "houseHoldChangesOnly": "Changements dans le ménage uniquement",
  "completed": "Profil complété",
  "notCompleted": "Profil non complété",
  "incompleteFields": "Champs incomplets",
  "allDocumentSigned": "Tous les documents signés",
  "unsignedDocuments_one": "1 document non signé",
  "unsignedDocuments_other": "{{count}} documents non signés",
  "unsignedDocumentsTooltip": "Signez les documents en accédant à l'onglet des documents.",
  "idVerified": "Identité vérifiée",
  "idNotVerified": "Identité non vérifiée",
  "idVerificationNotCompletedTooltip": "Ajoutez une preuve d'identité dans l'onglet des détails",
  "complianceApproved": "Conformité approuvée",
  "complianceNeedsReview": "Évaluation des besoins en matière de conformité",
  "complianceNeedsReviewTooltip": "Accédez à l'onglet de détails de chaque membre pour approuver les détails de conformité du client",
  "annualInfoUpToDate": "Renseignements annuels mis à jour",
  "annualInfoNeedsReview": "Mise à jour des renseignements annuels",
  "annualInfoNeedsReviewTooltip": "Le dernier examen d'aptitude a eu lieu il y a {{months}}+ mois. Mettez à jour les informations relatives au client en cliquant sur le bouton \"Modifier\" de l'état du profil dans l'onglet de détails du membre",
  "addModal": {
    "title": "Ajouter à un ménage",
    "name": "Nom du ménage",
    "type": "Type de ménage",
    "primaryUser": "Contact principal",
    "relationships": "Relations",
    "add": "Ajouter",
    "searchUser": "Recherche",
    "createARelation": "Créer des relations",
    "organization": "Organisation",
    "relation": "Relation",
    "relationUser": "Utilisateur de la relation",
    "nameRequired": "Le nom du ménage est obligatoire",
    "primaryUserRequired": "Le contact principal est obligatoire"
  },
  "updateModal": {
    "edit": "Modifier",
    "update": "Mettre à jour",
    "title": "Mise à jour du ménage"
  },
  "billingModal": {
    "title": "Mise à jour de la facturation du ménage"
  },
  "relationModal": {
    "email": "Courriel",
    "userEmail": "Courriel de l'utilisateur",
    "relationship": "Relation",
    "affiliationType": "Type d'affiliation",
    "firstName": "Prénom",
    "middleName": "Deuxième prénom",
    "lastName": "Nom de famille",
    "relationType": "Relation avec le membre principal",
    "permission": "Autorisation de ménage",
    "sin": "NAS",
    "allocation": "Allocation",
    "dateOfBirth": "Date de naissance",
    "relationTitle": "Ajouter une nouvelle relation",
    "updateRelationTitle": "Mise à jour de la relation",
    "createAUser": "Créer un nouvel utilisateur",
    "verifyUser": "Vérifier l'utilisateur",
    "errorMessage": "Aucun utilisateur de ce type. Veuillez cliquer sur",
    "here": "ici",
    "createMessage": "créer un nouvel utilisateur.",
    "addRelation": "Ajouter une relation",
    "updateRelation": "Mettre à jour",
    "removeAffiliate": "Supprimer l'affilié",
    "removeAffiliateConfirmation": "Êtes-vous sûr de vouloir supprimer cet affilié?",
    "organization": "Organisation des relations",
    "errorPre": "Veuillez cliquer ",
    "errorPost": " pour créer un nouvel affilié",
    "createAffiliate": "Créer un affilié",
    "addAffiliate": "Ajouter un affilié",
    "createUser": "Créer un nouvel utilisateur",
    "createNewClient": "Créer un nouveau client",
    "client": "Clients",
    "updateAffiliateTitle": "Mettre à jour un affilié"
  },
  "archiveHouseholdConfirmation": {
    "areYouSure": "Êtes-vous sûr?",
    "thereAreMembers": "Il y a {{numMembers}} client(s) dans ce ménage. Cette opération ne supprime pas les informations relatives au client, mais celui-ci ne sera plus associé à ce ménage.",
    "yesSure": "Oui, je suis sûr"
  },
  "types": {
    "household": "MÉNAGE",
    "business": "ENTREPRISE"
  },
  "table": {
    "headers": {
      "name": "Nom du ménage",
      "contact": "Contact principal",
      "email": "Courriel du contact principal",
      "relationCount": "Nombre de relations",
      "organization": "Organisation",
      "marketValue": "Valeur du marché"
    }
  },
  "summary": {
    "members": "Membres du ménage",
    "primaryContact": "Contact principal",
    "phone": "Téléphone",
    "email": "Courriel",
    "feeGrid": "Grille tarifaire",
    "billingCycle": "Cycle de facturation",
    "feePaymentAccount": "Compte de paiement des frais",
    "multiple": "Multiple",
    "inheritedDashWhat": "Hérité - {{what}}"
  },
  "tabs": {
    "overview": "Aperçu",
    "members": "Membres",
    "documents": "Documents",
    "statements": "Relevés",
    "transfers": "Virements",
    "ledger": "Grand livre",
    "trades": "Opérations",
    "notes": "Notes",
    "auditLog": "Rapport d'activité"
  },
  "overview": {
    "totalHouseholdAssets": "Total des actifs du ménage"
  },
  "membersTable": {
    "name": "Nom",
    "relationship": "Relation",
    "phoneNumber": "Numéro de téléphone",
    "email": "Courriel",
    "netWorth": "Valeur nette",
    "annualIncome": "Revenu annuel",
    "status": "Statut",
    "marketValue": "Valeur du marché",
    "permissions": "Autorisations",
    "editHouseholdMember": "Modifier le membre du ménage",
    "removeFromHousehold": "Retirer du ménage"
  },
  "remove": {
    "accountsExist": "Les comptes liés aux ménages existent",
    "thereAreAccountLinked": "{{clientName}} a {{count}} compte(s) lié(s) au ménage. Dissociez d'abord ce(s) compte(s).",
    "areYouSure": "Êtes-vous sûr de vouloir retirer {{clientName}} du {{householdName}}?",
    "thisWillNotDelete": "Cette opération ne supprime pas les informations relatives au client, mais celui-ci n'est plus associé à ce ménage.",
    "yesRemove": "Oui, retirer",
    "memberHasBeenRemoved": "Le client a été retiré du ménage"
  },
  "removeFromHousehold": {
    "title": "Retirer le client du ménage",
    "householdName": "Nom du ménage",
    "confirm": "Confirmer",
    "error": "Vous ne pouvez pas supprimer le propriétaire principal d'un ménage.",
    "success": "Le client a été retiré du ménage"
  },
  "householdStateLabel": "Type de ménage",
  "householdState": {
    "ACTIVE": "Actif",
    "ARCHIVED": "Archivé"
  },
  "accessTypes": {
    "EDIT": "Accès complet",
    "VIEW": "Accès complet",
    "NO_ACCESS": "Pas d'accès"
  }
}
